import styled from 'styled-components/macro'
import { transparentize } from 'polished'

export const Title = styled.h1`
  margin: 0;
  padding: 1.2rem 3.2rem;
  height: 4.6rem;
  font-size: 1.8rem;
  line-height: 1;
  letter-spacing: -0.018rem;
  text-align: center;
  border-bottom: 0.1rem solid ${(props) => props.theme.color.elementBorder};
`

export const Article = styled.article`
  margin: 0 auto;
  padding: 3.2rem 1.6rem;
  width: 100%;
  max-width: 70rem;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
`

export const Content = styled.div`
  margin: 2.6rem 0 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const ContentTitle = styled.h2`
  margin: 0 0 2rem;
  padding: 0;
  font-weight: ${(props) => props.theme.font.weight.bold};
  font-size: 2rem;
  line-height: 1.12;
  text-align: center;
  color: ${(props) => props.theme.color.text};
`

export const SelectorWrap = styled.div`
  margin: 0 0 4rem;
  padding: 0;
  width: 100%;
  min-width: 32rem;
  max-width: 60rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.6rem;
`

export const TitleList = styled.h3`
  margin: 0 0 0.4rem;
  width: 100%;
  font-weight: ${(props) => props.theme.font.weight.medium};
  font-size: 1.8rem;
  line-height: 1.4;
  text-align: left;
  color: ${(props) => props.theme.color.default};
`

export const List = styled.ol`
  margin: 0 0 3.2rem;
  padding: 1.8rem 3.2rem 1rem;
  list-style: none;
  counter-reset: li;
  background-color: ${(props) => transparentize(0.95, props.theme.color.elementBgSecond)};
`

export const ListItem = styled.li`
  position: relative;
  margin: 0 0 1.2rem;
  font-size: 1.4rem;
  line-height: 1.5;
  font-weight: ${(props) => props.theme.font.weight.regular};
  color: ${(props) => props.theme.color.text};
  &:last-child {
    margin: 0;
  }
  &::before {
    counter-increment: li;
    content: counters(li, '.') '. ';
    position: absolute;
    top: 0;
    left: -1.8rem;
    display: inline-block;
    font-weight: ${(props) => props.theme.font.weight.regular};
  }
`
